export default "__VITE_PUBLIC_ASSET__06fe4bd3__"